import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 9.70498L16.59 8.29498L12 12.875L7.41 8.29498L6 9.70498L12 15.705L18 9.70498Z",
		fill: "#696F88"
	})
});
export default SvgChevronDown;
